import { render, staticRenderFns } from "./COGSReport.vue?vue&type=template&id=9195a8ec&"
import script from "./COGSReport.vue?vue&type=script&lang=js&"
export * from "./COGSReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports